export default "__VITE_PUBLIC_ASSET__3df4ca0b__"